import { module as BaseModule } from 'modujs'
import gsap from 'gsap'
import Flip from 'gsap/dist/Flip'
gsap.registerPlugin(Flip)

export default class extends BaseModule {
  constructor(m) {
    super(m)
  }

  init() {
    // Check if the screen is mobile
    this.isMobile = window.innerWidth < 900

    // Set default state
    this.isAnimating = false
    this.filter = []
    this.filters = []
    this.btns = []

    this.lists = this.el.querySelectorAll('.filterList')

    this.lists.forEach((list, index) => {
      this.filters[index] = gsap.utils.toArray(
        list.querySelectorAll('.filterType')
      ) // Get Filters

      this.btns[index] = list.querySelector('.filterBtn') // Get Button

      this.filter[index] = 'all' // Default filter value
    })

    this.items = gsap.utils.toArray('.filterItem')
    this.grid = this.el.querySelector('.filterGrid')

    this.prevLength = this.items.length

    this.initEventListeners()
  }

  initEventListeners() {
    this.filters.forEach((filters, index) => {
      filters.forEach((btn, i) => {
        btn.addEventListener('click', () => {
          if (this.isAnimating) return
          this.setFilterActive(btn, index)

          this.filter[index] = btn.getAttribute('data-filter')
          this.updateFilters(this.filter)
        })
      })
    })

    this.btns.forEach((btn, i) => {
      btn.addEventListener('click', () => {
        this.toggleList(i)
      })
    })
  }

  updateFilters(filter) {
    this.isAnimating = true

    // First
    this.state = Flip.getState(this.items)
    const startHeight = this.grid.offsetHeight

    this.matches = this.items

    filter.forEach((fil, i) => {
      if (fil !== 'all') {
        // Skip if filter is all
        this.matches = this.matches.filter((el) =>
          el.getAttribute('data-filter').includes(fil)
        )
      }
    })

    // Last
    this.items.forEach((item) => {
      item.style.display = this.matches.indexOf(item) === -1 ? 'none' : 'block'
    })

    if (this.prevLength > this.matches.length) {
      this.grid.style.height = 'auto'
    }
    const endHeight = this.grid.scrollHeight

    this.grid.style.height = startHeight + 'px'

    this.prevLength = this.matches.length

    // Invert & Play
    this.flip = Flip.from(this.state, {
      duration: 0.5,
      ease: 'power1.inOut',
      stagger: 0,
      absolute: true,
      simple: true,
      onEnter: (elements) => {
        gsap.fromTo(elements, { opacity: 0 }, { opacity: 1, duration: 0.5 })
      },
      onLeave: (elements) => {
        gsap.to(elements, { opacity: 0, duration: 0.5 })
      },
      onComplete: () => {
        this.isAnimating = false
      },
    })

    gsap.fromTo(
      this.grid,
      {
        height: startHeight,
      },
      {
        height: endHeight,
        duration: 0.5,
      },
      '<'
    )
  }

  setFilterActive(el, index) {
    this.filters[index].forEach((btn) => {
      btn.classList.remove('--active')
      btn.style.pointerEvents = 'auto'
    })
    el.classList.add('--active')
    el.style.pointerEvents = 'none'
  }

  toggleList(i) {
    this.lists[i].style.setProperty(
      '--filter-list-height',
      `${this.lists[i].querySelector('.c-list-wrap').scrollHeight}px`
    )
    this.btns[i].classList.toggle('--active')
  }
}
